












































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class CalculationFormulaInput extends Vue {
  @Prop(Number) unitId: any;
  private dataText: any = '123123';
  private drawer = false;

  private form: any = {
    title: '计算公式',
    placeholder: '自动计算数值',
    required: false,
    relatedPay: '',
  };
  closeTap() {
    console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }
}
